<!--
  PRIVATE COMPONENT
  This component is designed to be used exclusively within the EdroneButton component and not as a standalone component.
-->

<template>
  <div class="EdroneButtonBorderAnimation__border-mask">
    <div
      :class="[
        'EdroneButtonBorderAnimation__border-glow',
        `EdroneButtonBorderAnimation__border-glow--${props.typeButton}`,
      ]"
    />
  </div>
</template>

<script setup lang="ts">
import type { ButtonType } from "./EdroneButton.types";

interface Props {
  typeButton?: ButtonType;
}

const props = withDefaults(defineProps<Props>(), {
  typeButton: "ai-solid",
});
</script>

<style scoped>
.EdroneButtonBorderAnimation__border-mask {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  padding: 1px;
  inset: -1px;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  overflow: hidden;
}

.EdroneButtonBorderAnimation__border-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30rem;
  height: 30rem;
  transform: translate(-50%, -50%);
  transform-origin: 0 0;
  animation: rotateGlow 3s linear infinite;
}

.EdroneButtonBorderAnimation__border-glow:hover {
  background: transparent;
  animation: none;
}

.EdroneButtonBorderAnimation__border-glow--ai-solid {
  background: conic-gradient(transparent 30%, #bbabfd, #7656fb, #7656fb, #7656fb, #bbabfd, transparent);
}

.EdroneButtonBorderAnimation__border-glow--ai-outline {
  background: conic-gradient(transparent 30%, #ddd5fe, #bbabfd, #bbabfd, #bbabfd, #ddd5fe, transparent);
}

@keyframes rotateGlow {
  0% {
    transform: rotate(0deg) translate(-50%, -50%);
  }
  100% {
    transform: rotate(360deg) translate(-50%, -50%);
  }
}
</style>
